import { Stack, Typography } from "@mui/material";
import UserAvatar from "../UserAvatar/UserAvatar";
import TextWithIcon from "../TextWithIcon";
import { toLocalDate } from "../../utils/formatData";
import { FiCalendar, FiMail } from "react-icons/fi";
import { useTheme } from "@mui/material";

const UserInfo = ({ user }) => {
    const theme = useTheme();
    return (
        <Stack spacing={2}>
            <Stack direction="row" spacing={2} alignItems={"center"}>
                <UserAvatar name={`${user?.name} ${user?.surname}`} size={60} />
                <Typography
                    variant="h4"
                    gutterBottom
                    color={theme.palette.text.primary}
                >
                    {user?.name} {user?.surname}
                </Typography>
            </Stack>
            <TextWithIcon Icon={FiMail} text={user?.email} />
            <TextWithIcon text={user?.client_code} />
            <TextWithIcon
                Icon={FiCalendar}
                text={toLocalDate(user?.created_at)}
            />
        </Stack>
    );
};

export default UserInfo;
